module.exports = __webpack_public_path__ + "img/en-US.29ec6187.svg";